import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { WindowScrollService } from 'src/app/core/services/window-scroll.service';
import { Professional } from 'src/app/core/models/professional';

@Component({
  selector: 'app-professional-modal',
  templateUrl: './professional-modal.component.html',
  styleUrls: ['./professional-modal.component.scss']
})
export class ProfessionalModalComponent implements OnInit {

  @Output() public closeModal = new EventEmitter<boolean>();
  @Output() public sendItems = new EventEmitter<Professional>();
  @Input() public titleModal = '';

  public professionalForm: FormGroup;
  public listType = [
    {
      name: 'Corretor'
    },
    {
      name: 'Vendedor'
    },
    {
      name: 'Atendimento'
    },
    {
      name: 'Supervisor'
    },
    {
      name: 'Captação de Vendas'
    },
    {
      name: 'Captação de Corretor'
    }
  ];
  public listEnterprise = [
    {
      name: 'Empresa A'
    },
    {
      name: 'Empresa B'
    },
    {
      name: 'Empresa C'
    },
    {
      name: 'Empresa D'
    },
    {
      name: 'Empresa E'
    },
    {
      name: 'Empresa F'
    }
  ];

  constructor(
    private fb: FormBuilder,
    private scroll: WindowScrollService
  ) { }

  ngOnInit(): void {
    this.scroll.disable();
    this.initializeForm();
  }

  private initializeForm() {
    this.professionalForm = this.fb.group({
      type: [null],
      name: [null],
      enterprise: [null]
    });
  }

  public sendItem() {
    this.sendItems.emit(this.professionalForm.value);
    this.closeActionModal();
  }

  public closeActionModal() {
    this.scroll.enable();
    this.closeModal.emit(false);
  }


}